// extracted by mini-css-extract-plugin
export default {"containerStyle":"styles_containerStyle__X5uRE","containerWrapperStyle":"styles_containerWrapperStyle__W6JoP","headerTextStyle":"styles_headerTextStyle__TxSMO"};